import { observer } from 'mobx-react';
import React, { SyntheticEvent, useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import { FormattedMessage } from 'react-intl';
import SlidingPanel from 'react-sliding-side-panel';
import noMessageIcon from '../../assets/Images/no-process.png';
import { ProcessTypeEnum } from '../../constants/enums';
import { ModuleType } from '../../constants/enums/module-type-enum';
import userSettingEnum from '../../constants/enums/user-setting-enum';
import { GridRemoteConstant } from '../../constants/grid-constant';
import { useStore } from '../../contexts/store-provider';
import {
  ProcessDefaultSortColumnOrder,
  ProcessFilterInitialState,
} from '../../core/initialState/filter-initial-state';
import {
  isOperationPermittedRoleBase,
  showIconsRoleBase,
} from '../../helpers/action-permission-helper';
import IPageInfo, {
  IActionFormatter,
  IPageLimitInfo,
} from '../../models/ICommon';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IProcessFilter } from '../../models/IProcessFilter';
import FormLoader from '../../shared-components/FormLoader/FormLoader';
import Grid from '../../shared-components/Grid/Grid';
import { CustomActionFormatter } from '../../shared-components/Grid/GridFormatter';
import Pagination from '../../shared-components/Grid/Pagination';
import FilterPopupHOC from '../../shared-components/hoc/filter-popup-hoc/filter-popup-hoc';
import DeletePopup from '../../shared-components/popup/delete/delete-popup';
import DeletePopupHOC from '../../shared-components/popup/delete/delete-popup-hoc';
import {
  CloseSidePanelIcon,
  DeleteIcon,
  EditIcon,
  PlusIcon,
  RefreshIcon,
  DimensionIcon,
} from '../../shared-components/svgs/svgs';
import { formatMessage } from '../../translations/format-message';
import AddProcess from './components/add-edit-process';
import FilterComponent from './components/filter';
import AddProcessPopupHOC from './hoc/add-process-popup-hoc';
import ProcessDetails from './process-details';
import './process.css';


const Process = (props: any) => {
  const { processStore, preferencesStore } = useStore();
  const {
    GetProcessListService,
    allProcess,
    processList,
    deleteProcessState,
    DeleteProcessService,
    resetDeleteProcess,
    resetProcessDetail,
    addUpdateProcessState,
    resetAddUpdateProcessState,
    processState,
    getAllProcessState,
    saveDimensionDataState,
    resetSaveDimensionDataState
  } = processStore;

  const {
    userSetting,
    setUserSetting,
    language,
    islanguageChanged,
    updateLanguageChangedFlag,
  } = preferencesStore;

  let lang: string;
  const allProcessListData = allProcess;
  const isFirstLoad = useRef(true);
  const [disablePagination, setDisablePagination] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedId, setSelectedId] = useState(0);
  const [openPanel, setOpenPanel] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [columSortOrder, setColumnSortOrder] = useState<IDefaultColumSortOrder>(
    ProcessDefaultSortColumnOrder
  );
  const [filterObj, setFilterObj] = useState<IProcessFilter>(
    ProcessFilterInitialState
  );
  const [isFilterApplied, setIsFilterApplied] = useState<boolean>(false);
  const pageLimitOptions: Array<number> = [10, 20, 50, 100];

  const [pageLimitInfo, setPageLimit] = useState<IPageLimitInfo>({
    pageLimit: userSetting.pageLimitConfig,
    isPageLimitChange: false,
  });

  const [pageInfo, setPageInfo] = useState<IPageInfo>({
    currentPage: 1,
    totalPages: 1,
    isPagerChange: false,
    isRefreshPage: false,
  });

  const onPageChanged = (pageNumber: number) => {
    closePanelHandler();
    setPageInfo({ ...pageInfo, currentPage: pageNumber, isPagerChange: true });
  };

  const setIsRefreshPage = () => {
    setPageInfo({ ...pageInfo, isRefreshPage: false });
  };

  const onPageLimitChanged = (evt: any) => {
    let pages: number;
    pages = props.data && Math.ceil(props.data.length / evt.target.value);
    setPageInfo({
      ...pageInfo,
      currentPage: 1,
      totalPages: pages,
      isPagerChange: false,
    });
    setPageLimit({
      pageLimit: parseInt(evt.target.value),
      isPageLimitChange: true,
    });
    setUserSetting(userSettingEnum.UserLimitConfig, parseInt(evt.target.value));
  };

  const getProcessListServiceHandler = (
    filterQuery?: string,
    isFilter = false
  ) => {
    if (!filterQuery) {
      filterQuery = createQueryString({
        ...filterObj,
        Column: columSortOrder.dataField,
        Order: columSortOrder.order,
      });
    }
    if (!isFilter) {
      GetProcessListService(
        pageInfo.currentPage,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    } else {
      GetProcessListService(
        1,
        pageLimitInfo.pageLimit,
        encodeURIComponent(filterQuery)
      );
    }
  };

  useEffect(() => {
    getProcessListServiceHandler();
  }, []);

  useEffect(() => {
    if (islanguageChanged) {
      updateLanguageChangedFlag();
    }
  }, [islanguageChanged]);
  useEffect(() => {
    setPageInfo({
      ...pageInfo,
      currentPage: processList?.PagingDetails?.CurrentPage ?? 0,
      totalPages: processList?.PagingDetails?.TotalPages ?? 0,
      isPagerChange: false,
    });
    setDisablePagination(false);
  }, [processList]);
  // useEffect(() => {
  //   setPageInfo({
  //     ...pageInfo,
  //     totalPages: processList?.PagingDetails?.TotalPages,
  //     isPagerChange: false,
  //   });
  //   setDisablePagination(false);
  // }, [processList]);

  useEffect(() => {
    if (pageInfo.isPagerChange) {
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageInfo.currentPage]);

  useEffect(() => {
    if (pageLimitInfo.isPageLimitChange) {
      getProcessListServiceHandler();
      setPageLimit({ ...pageLimitInfo, isPageLimitChange: false });
    }
  }, [pageLimitInfo.pageLimit]);

  useEffect(() => {
    if (lang && language !== lang) {
      getProcessListServiceHandler();
    }
  }, [language]);

  useEffect(() => {
    if (addUpdateProcessState.success) {
      resetAddUpdateProcessState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUpdateProcessState.success]);

  useEffect(() => {
    if (deleteProcessState.success) {
      toast.success(formatMessage('deleted_success'));
      props.deletePopupToggleHandler();
      resetDeleteProcess();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteProcessState.success]);

  useEffect(() => {
    if (saveDimensionDataState.success) {
      resetSaveDimensionDataState();
      getProcessListServiceHandler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveDimensionDataState.success]);

  function rowClassFormat(row: any, rowId: number) {
    let className: string = '';
    if (selectedRow?.Id && row.Id === selectedRow.Id) {
      className = 'bg-row SelectedRow';
    }
    return className;
  }

  const rowEvents = (e: SyntheticEvent, row: any) => {
    // GetProcessByIdService(row.Id);
    setSelectedRow(row);
    if (selectedRow.Id === undefined || selectedRow.Id !== row.Id) {
      setOpenPanel(true);
    } else {
      setOpenPanel(!openPanel);
    }
  };

  const closePanelHandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const refreshClickHandler = () => {
    getProcessListServiceHandler();
    closePanelHandler();
  };

  const deleteHandler = () => {
    DeleteProcessService(selectedId);
  };

  const deleteClickHandler = (
    row: any,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setSelectedId(row.Id);
    event.stopPropagation();
    closePanelHandler();
    resetProcessDetail();
    props.deletePopupToggleHandler();
  };

  const openAddProcessHandler = (
    row: { Id: number },
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    event.stopPropagation();
    closePanelHandler();
    resetProcessDetail();
    setSelectedId(row.Id);
    props.addToggleHandler();
  };

  const createQueryString = (filter: IProcessFilter): string => {
    return Object.entries(filter)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('#');
  };

  const filterHandler = (object: IProcessFilter) => {
    const filters = {
      ...object,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    };
    const filter = createQueryString({ ...filters });
    getProcessListServiceHandler(filter, true);
    setFilterObj({ ...filters });
    props.filterPopupToggleHandler();
    closePanelhandler();
    setIsFilterCleared(false);
  };

  const closePanelhandler = () => {
    setSelectedRow({});
    setOpenPanel(false);
  };

  const filterParams = (obj: IProcessFilter, isfilterCleard: boolean) => {
    const filter = createQueryString({
      ...obj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    if (isfilterCleard) {
      setFilterObj({ ...obj });
      getProcessListServiceHandler(filter);
      closePanelhandler();
      setIsFilterCleared(true);
    } else {
      setFilterObj({ ...obj });
    }
    props.filterPopupToggleHandler();
  };

  const handleTableChange = (type: any, newState: any) => {
    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    setColumnSortOrder((prevState) => ({
      ...prevState,
      dataField: newState.sortField,
      order: newState.sortOrder,
    }));
  };

  useEffect(() => {
    const filter = createQueryString({
      ...filterObj,
      Column: columSortOrder.dataField,
      Order: columSortOrder.order,
    });

    getProcessListServiceHandler(filter);
  }, [columSortOrder]);

  const actionIcons: IActionFormatter[] = showIconsRoleBase(
    [
      {
        dataField: 'isEdit',
        handler: openAddProcessHandler,
        icon: <EditIcon />,
        // isDisable: !isOperationPermittedRoleBase(
        //   ModuleType.ProcessManagement,
        //   'Edit'
        // ),
        isDisable: true,
        title: 'edit',
        varient: 'primary',
        action: 'edit',
      },
      {
        dataField: 'isDelete',
        handler: deleteClickHandler,
        icon: <DeleteIcon />,
        // isDisable: !isOperationPermittedRoleBase(
        //   ModuleType.ProcessManagement,
        //   'Delete'
        // ),
        isDisable: true,
        title: 'delete',
        varient: 'danger',
        action: 'delete',
      },
    ],
    ModuleType.ProcessManagement
  );

  const columns: any = [
    {
      dataField: 'serialNumber',
      text: formatMessage('serial_number'),
      classes: 'show-Elipses',
      isDummyField: true,
      formatter: (_: any, __: any, rowIndex: number) => rowIndex + 1,
      sort: false,
    },
    {
      dataField: 'Id',
      text: formatMessage('label_id'),
      classes: 'show-Elipses',
      hidden: true,
    },
    {
      dataField: 'ProcessName',
      text: formatMessage('process_name'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
      sort: true,
    },
    {
      dataField: 'ShortName',
      text: formatMessage('short_name'),
      sort: true,
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    {
      dataField: 'Type',
      text: formatMessage('process_type'),
      sort: true,
      classes: 'processType',
      formatter: (cell) => {
        let highlightClass = '';
        if (cell === ProcessTypeEnum[0]) {
          highlightClass = 'productionProcess badge';
        } else if (cell === ProcessTypeEnum[1]) {
          highlightClass = 'testingProcess badge';
        } else if (cell === ProcessTypeEnum[2]) {
          highlightClass = 'printProcess badge';
        } else {
          highlightClass = 'pickingProcess badge';
        }
        return (
          <div className={`${highlightClass}`}>
            <FormattedMessage id={cell} />
          </div>
        );
      },
      title: (cell: string) => {
        return cell.length > 10 ? formatMessage(cell) : undefined;
      },
    },
    {
      dataField: 'Comment',
      text: formatMessage('comment'),
      classes: 'show-Elipses',
      title: (cell: string) => {
        return cell.length > 10 ? cell : undefined;
      },
    },
    // {
    //   dataField: '',
    //   formatter: CustomActionFormatter(actionIcons),
    //   text: formatMessage('actions'),
    //   classes: 'last-column',
    //   hidden: actionIcons.length > 0 ? false : true,
    // },
  ];

  return (
    <>
      {props.showAddProcessPopup && (
        <AddProcess
          id={selectedId}
          modalClosed={props.addToggleHandler}
        />
      )}
      {props.showDeletePopup && (
        <DeletePopup
          title="delete_process"
          modalSubmit={deleteHandler}
          modalClosed={props.deletePopupToggleHandler}
          message="message_delete_process_confirm"
          isLoading={deleteProcessState.inProgress}
        />
      )}
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <div className="page_title_wrap">
              <h1 className="page_title">
                <FormattedMessage id="process_title" />
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <FormattedMessage id="home" />
                </li>
                <li
                  className="breadcrumb-item active"
                  aria-current="page"
                >
                  <FormattedMessage id="process_title" />
                </li>
              </ol>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="add-list">
              <li>
                <FilterComponent
                  initialValues={filterObj}
                  id={0}
                  submitHandler={filterHandler}
                  filterParmas={filterParams}
                  onModalClosed={props.filterPopupToggleHandler}
                  isFilterCleared={isFilterCleared}
                  isLoading={false}
                  isDisable={false}
                  isFilterApplied={isFilterApplied}
                  setIsFilterApplied={setIsFilterApplied}
                />
              </li>
              <li title={formatMessage('refresh')}>
                <a
                  data-toggle="modal"
                  className="btn btn-light"
                  onClick={() => refreshClickHandler()}
                >
                  <RefreshIcon />
                </a>
              </li>
              {isOperationPermittedRoleBase(
                ModuleType.ProcessManagement,
                'Add'
              ) && (
                <li
                  title={formatMessage('add_process')}
                  className="mt-1"
                >
                  <a
                    className="btn btn-secondary"
                    data-toggle="modal"
                    data-testid="modalbtn"
                    data-target="#addUser"
                    onClick={(event: any) =>
                      openAddProcessHandler({ Id: -1 }, event)
                    }
                  >
                    <span className="me-1">
                      <PlusIcon />{' '}
                    </span>
                    <FormattedMessage id="add_process" />
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className={`${openPanel ? 'panelOpen' : ''}`}>
        <div className="card card-page">
          {(getAllProcessState.inProgress ||
            processState.inProgress ||
            deleteProcessState.inProgress) && (
            <FormLoader
              loading={
                getAllProcessState.inProgress ||
                processState.inProgress ||
                deleteProcessState.inProgress
              }
            />
          )}
          {allProcessListData && allProcessListData.length > 0 ? (
            <>
              <div>
                <div className="tableDesign row-eq-height tableDevices p-3 changingPanel">
                  <div
                    className="table-responsive"
                    data-testid="table"
                  >
                    {allProcessListData && (
                      <Grid
                        data={allProcessListData}
                        columns={columns}
                        keyField="Id"
                        loading={false}
                        rowClasses={rowClassFormat}
                        rowEvents={{ onClick: rowEvents }}
                        hover={true}
                        sort={{ ...columSortOrder }}
                        remote={{ ...GridRemoteConstant }}
                        onTableChange={handleTableChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              {allProcessListData.length > 0 ? (
                <div className="row no-gutters p-3 pt-0 tableFooter">
                  <div className="col-lg-3 col-md-6 col-sm-6 pt-1">
                    <FormattedMessage id="show" />
                    <select
                      data-testid="pageSelect"
                      className="pageLimit"
                      onChange={onPageLimitChanged}
                      value={pageLimitInfo.pageLimit}
                    >
                      {pageLimitOptions.map((op: any) => (
                        <option
                          key={op}
                          value={op}
                        >
                          {op}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg-9 col-md-6 col-sm-6 d-flex justify-content-sm-end">
                    <Pagination
                      isRefreshPage={false}
                      totalPages={pageInfo.totalPages}
                      pageLimit={pageLimitInfo.pageLimit}
                      onPageChanged={onPageChanged}
                      disablePagination={disablePagination}
                      setIsRefreshPage={setIsRefreshPage}
                      currentPage={pageInfo.currentPage}
                      totalRecords={
                        processList?.PagingDetails?.TotalRecords ?? 0
                      }
                    />
                  </div>
                </div>
              ) : (
                ''
              )}
            </>
          ) : (
            <div className="message">
              <div className="d-flex message-area">
                <div className="no-data-img">
                  <img
                    src={noMessageIcon}
                    alt=""
                    className="no_message"
                  />
                </div>
                <div>
                  <h3 className="fw-bold display-6">
                    {' '}
                    <FormattedMessage id="no_process" />
                  </h3>
                  <h4 className="mb-3">
                    {formatMessage('no_process_message')}
                  </h4>
                  {isOperationPermittedRoleBase(
                    ModuleType.ProcessManagement,
                    'Add'
                  ) && (
                    <>
                      <a
                        className="btn btn-primary"
                        onClick={(event: any) =>
                          openAddProcessHandler({ Id: -1 }, event)
                        }
                      >
                        <span className="me-1">
                          <PlusIcon />{' '}
                        </span>
                        <FormattedMessage id="add_process" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <SlidingPanel
        type={'right'}
        isOpen={openPanel}
        noBackdrop={false}
        size={100}
      >
        <div className="bg_slide panel">
          <div className="row bb p-2 pl-4 g-0 align-items-center ">
            <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10">
              <h2 className="fw-bold mb-0 mt-1 ms-2 py-2">
                {selectedRow.ProcessName}
              </h2>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 close-icon-detail">
              <span title={formatMessage('close')}>
                <CloseSidePanelIcon closePanelHandler={closePanelHandler} />
              </span>
            </div>
          </div>
          <div className="group_detailsWrapper pb-3">
            <ProcessDetails selectedRowId={selectedRow.Id} />
          </div>
        </div>
      </SlidingPanel>
    </>
  );
};

export default FilterPopupHOC(
  AddProcessPopupHOC(DeletePopupHOC(observer(Process)))
);
